<template lang="pug">
  b-form(novalidate @submit.prevent="updateSecurity" :disabled="!submission.success")
    //- .form-group
    //-   label {{ $t("ui.security_tag") }}
    //-   DebounceInput(
    //-     type="text"
    //-     ref="security_tag"
    //-     :dirty="$v.security_tag.$dirty"
    //-     :error="$v.security_tag.$error"
    //-     :placeholder='$t("ui.security_tag")'
    //-     v-model.trim.lazy="$v.security_tag.$model"
    //-     :maxLength="$v.security_tag.$params.maxLength.max"
    //-     :disabled="loading"
    //-   )
    //-   ValidateResult(:value="$v.security_tag" :name="$t('ui.security_tag')")
    .form-group
      label {{ $t("ui.security_code") }}
      b-input-group.input-group-sm
        DebounceInput(
          type="text"
          ref="security_code"
          :dirty="$v.security_code.$dirty"
          :error="$v.security_code.$error"
          :placeholder='$t("ui.security_code")'
          v-model.trim.lazy="$v.security_code.$model"
          :maxLength="$v.security_code.$params.maxLength.max"
          :disabled="loading"
        )
        .input-group-append(style="cursor: pointer;")
          SecurityCodeRules
        ValidateResult(:value="$v.security_code" :name="$t('ui.security_code')" :errors="securityCodeErrors")
    .form-group
      label {{ $t("ui.confirm_security_code") }}
      DebounceInput(
        type="text"
        ref="confirm_security_code"
        :dirty="$v.confirm_security_code.$dirty"
        :error="$v.confirm_security_code.$error"
        :placeholder='$t("ui.confirm_security_code")'
        v-model.trim.lazy="$v.confirm_security_code.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.confirm_security_code" :name="$t('ui.confirm_security_code')" :name2="$t('ui.new_security_code')")
    .form-group
      b-form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    .form-group
      b-form-group
        SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.reset')" isModal=false type="button"  @click="clear()" :disabled="$helpers.isSuspended()")
        SubmitButton.ml-2(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=false type="button" @click="securityUpdate()" :disabled="$helpers.isSuspended()")
        //- SubmitButton(
        //-   v-if="$store.getters.securityDisabled == 0"
        //-   style="float:right;"
        //-   :loading="loading"
        //-   icon='fa fa-times'
        //-   isModal=false
        //-   variant="danger"
        //-   type="button"
        //-   :text="$t('ui.disabled')"
        //-   @click="disabledSecurity()"
        //-   :disabled="$helpers.isSuspended()"
        //- )
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, sameAs, helpers } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import SecurityCodeRules from "@/library/SecurityCodeRules";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    SecurityCodeRules
  },
  data() {
    return {
      security_disabled: false,
      // security_tag: this.$store.getters.securityTag,
      security_tag: "MS",
      security_code: "",
      confirm_security_code: "",
      securityCodeErrors: [],
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/settings"
    }
  },
  validations: {
    // security_tag: {
    //   required,
    //   minLength: minLength(6),
    //   maxLength: maxLength(20)
    // },
    security_code: {
      required,
      valid: function(value) {
        if (!helpers.req(value)) return true;
        return this.$helpers.validateSecurityCode(value).isValid;
      },
      minLength: minLength(6),
      // maxLength: maxLength(20)
      maxLength: maxLength(6)
    },
    confirm_security_code: {
      required,
      sameAs: sameAs("security_code")
    }
  },
  watch: {
    security_code(value) {
      if (!value) {
        this.securityCodeErrors = [];
        return;
      }
      const result = this.$helpers.validateSecurityCode(value);
      this.securityCodeErrors = result.errors;
    }
  },
  methods: {
    reset: function() {
      this.$v.$reset()
      this.submission.success = true
      this.submission.status = ""
    },
    clear: function() {
      // this.security_tag = ""
      this.security_code = ""
      this.confirm_security_code = ""
      this.$nextTick(() => {
        this.reset();
      });
    },
    disabledSecurity: function() {
      this.loading = true;
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.update_account_security_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("user/securityDisable")
            .then(response => {
              this.loading = false;
              this.submission.success = response.success;
              this.$swal({
                title: this.$t("ui.succeed"),
                text: this.$t("message.update_account_security_success"),
                type: "success",
                allowOutsideClick: false
              }).then(isConfirm => {
                if (isConfirm) {
                  this.clear();
                  this.cancel();
                }
              });
            })
            .catch(response => {
              this.loading = false;
              this.submission.success = response.success;
              this.submission.status = this.$t("message." + response.errorTag);
            });
        } else if (
          // Read more about handling dismissals
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.update_account_security_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.cancel();
            }
          });
        }
      });
    },
    securityUpdate: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_security_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            let security_tag = this.security_tag
            let security_code = this.security_code
            this.loading = true;
            this.$store
              .dispatch("user/securityUpdate", { security_tag, security_code })
              .then(response => {
                this.loading = false;
                this.submission.success = response.success;
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.update_account_security_success"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    this.security_code = "";
                    this.confirm_security_code = "";
                    this.$v.$reset();
                    this.cancel();
                  }
                });
              })
              .catch(response => {
                this.loading = false;
                this.submission.success = response.success;
                this.submission.status = this.$t("message." + response.errorTag);
              });
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_security_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    cancel: function() {
      this.$router.push("/settings").catch(err => {})
    }
  }
}
</script>
